import React, { useState } from 'react';
import CountUp from 'react-countup';

const CountUpMoney = ({ money,symbol=true }) => {

    return (
        <>{<CountUp end={money} separator="," decimals={2} decimal="."  />} {symbol ? '₮' : ''}</>
    );
};

export default CountUpMoney;
